"use strict";
export const CONNECTION_PROVIDER_IDS = {
  WALLET_CONNECT_CONNECTOR_ID: "walletConnect",
  INJECTED_CONNECTOR_ID: "injected",
  INJECTED_CONNECTOR_TYPE: "injected",
  COINBASE_SDK_CONNECTOR_ID: "coinbaseWalletSDK",
  COINBASE_RDNS: "com.coinbase.wallet",
  METAMASK_RDNS: "io.metamask",
  SAFE_CONNECTOR_ID: "safe",
  MOCK_CONNECTOR_ID: "mock",
  BINANCE_W3W_CONNECTOR_ID: "wallet.binance.com"
};
